<div class="container">
    <div class="row">
        <div class="title title-wrap" kendoTooltip>
            <span class="h1-light sub-title" *ngIf="!isEdit"
                [ngClass]="{'view-name': viewNameColor,'home-screen-sub-title':isHomeScreen}" tamDynamicTooltip
                [title]="currentViewName" (click)="onLayoutsShowContextMenu($event)">{{currentViewName}}</span>
            <input #livewireNameInput type="text" maxlength="128" *ngIf="isEdit" [(ngModel)]="currentViewName"
                (blur)="disableChangeLivewireName(currentViewName)"
                (keypress)="keypressForChangeLivewireName($event)" />
            <div *ngIf="currentPageInfo.type === 'CREATE_BLASTEMAIL' && isPPCUser" tid="contact_edit" class="item-edit"
                (click)="onChangeLivewireName()">
                <smart-icon name="pencil" class="light"></smart-icon>
            </div>
            <smart-icon *ngIf="isHomeScreen" name="angle-down" class="layouts-container"
                (click)="onLayoutsShowContextMenu($event)" tid="layout_angledown">
            </smart-icon>
        </div>
        <div class="operation-box" *ngIf="showOperationBox">
            <button tam-button tamType="primary" tamSize="normal" (click)="onSaveClick()"
                *ngIf="showSaveButton && !isIPAD">{{btnName}}</button>
            <smart-icon *ngIf="isHasPermission && !isIPAD" name="meatball" class='operation-area light'
                (click)="onOperationShowContextMenu($event)" tid="layout_meatball">
            </smart-icon>
            <smart-icon name="export-excel" (click)="exportToExcel()" class="light" kendoTooltip position="left"
                title="{{'general.export_to_excel' | stringLiterals}}" *ngIf="isUsageReport && !isIPAD"></smart-icon>
        </div>
    </div>
    <tam-context-menu [config]="layoutsContextMenuConfig"></tam-context-menu>
    <tam-context-menu [config]="operationContextMenuConfig"></tam-context-menu>
</div>